import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutPageComponent } from '../layout/pages/layout.page/layout.page.component';
import { LayoutPageAndMapComponent } from '../layout/pages/layout-page-and-map/layout-page-and-map.component';
import { ContextResolverService } from '../shared/sharedServices/contextResolver.service';
import { RequestComponent } from './pages/request/request.component';
import { ServicesComponent } from './pages/services/services.component';
import { ProgramComponent } from './pages/program/program.component';
import { MuRouteData } from '../shared/models/interface/muRouteData.interface';
import { CreatePageComponent } from './pages/create/create.page.component';
import { MassiveNewRoutingSearchComponent } from './pages/new-routing-search/massive-new-routing-search.component';
import { MassiveCfdiComponent } from './pages/cfdi/massive-cfdi.component';
import { MassiveNewRoutingCreateComponent } from './pages/new-routing-create/massive-new-routing-create.component';
import { DeliveriesComponent } from './pages/deliveries/deliveries.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutPageComponent,
    resolve: {
      context: ContextResolverService,
    },
    children: [
      {
        path: 'request',
        component: RequestComponent,
        data: MuRouteData({
          breadcrumb: 'loadExcelRequests',
        }),
      },
      {
        path: 'create',
        component: CreatePageComponent,
        data: MuRouteData({
          breadcrumb: 'loadExcelRequests/excelUpload',
        }),
      },
      {
        path: 'program/:requestId',
        component: ProgramComponent,
      },
      {
        path: '',
        component: LayoutPageAndMapComponent,
        children: [
          {
            path: 'services/:requestId',
            component: ServicesComponent,
            data: MuRouteData({
              breadcrumb: 'loadExcelRequests/excelPackages',
            }),
          },
        ],
      },
      {
        path: 'new-routing',
        component: MassiveNewRoutingSearchComponent
      },
      {
        path: 'cfdi',
        component: MassiveCfdiComponent,
      },
      {
        path: 'new-create',
        component: MassiveNewRoutingCreateComponent,
      },
      {
        path: 'deliveries',
        component: DeliveriesComponent,
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MassiveRoutingModule {}
